import React from "react";
import { Helmet } from "react-helmet";
import Banner from "../../../component/Banner";
import image1 from "../../../images/insurance/insurance2.webp";
import { Link } from "react-router-dom";
const Reinsurance = () => {
  const banner = {
    title: "Reinsurance Solutions ",
    image: image1,
  };

  return (
    <>
      <Helmet>
        <title>
          Reinsurance — Cylon Technologies – Big Data | Data Analytics | Digital Strategy
        </title>
      </Helmet>
      <Banner heading={banner.title} bannerimg={banner.image} />
      <section className="sec-padd page_content heading_space pb-5 small_ul">
        <div className="container">
          <div className="row g-md-5 g-4 justify-content-between">
            <div className="col-md-7">
              <h2 className="heading2">Reinsurance Solutions </h2>
              <p>
                The unprecedented volatility in financial markets is creating new risks and opportunities for organization across the global economies. Reinsurance is useful in managing the exposures that may exceed the risk capacity provided in the treaties or otherwise helps in reducing the overall efficiency of treaties in terms of pricing, structure and market. Insurance companies need to have a reinsurance program to reduce their exposure to loss by passing on part of their risk or loss to a reinsurer or group of insurers.
              </p>
              <p>
                Cylon Technologies reinsurance solutions come with a host of industry standard best practices with a user friendly interface.  We specialize in providing reinsurance solutions for large and complex risks across business sectors such as aviation, agriculture, casualty, credit & surety, engineering, energy and much more. Our reinsurance solutions protect portfolios from unforeseen exposures and rapid fluctuations while maintaining a healthy loss ratio.
              </p>
              <p>
                An effective reinsurance system must optimize operational activities that include business accuracy, allocations, and calculations as well as help in providing improved efficiency and control. Cylon Technologies Reinsurance is a complete comprehensive system providing superior solutions for both ceded insurance and assumed reinsurance. We have decades of experience in evaluating, underwriting, and managing a variety of life and health risks by ensuring that you have direct access to the resources you need to produce profitable results thereby meeting your business goals.
              </p>
              <h5 className="mb-4 mt-5">
                <b> Why Cylon Technologies Reinsurance Solutions – Overview</b>
              </h5>
              <p>
                Cylon Technologies reinsurance solutions are well designed to manage a wide range of complex reinsurance contracts that involve multiple ceding criteria and help in mitigating the risks, thereby delivering comprehensive protection. The Key Reinsurance Solutions that we provide include –
              </p>
              <h5 className="mb-4 mt-5">
                <b> Life/Health-</b>
              </h5>
              <p>Cylon Technologies offers you tailor made reinsurance programs that help you in achieving life/health risk management objectives. Our team of reinsurance experts has expertise in providing you with competent advice, comprehensive services and effective tools to guide your risk management decisions through the following activities-</p>

              <ul>
                <li>Underwriting programs, that includes facilitative or proprietary programs</li>
                <li>Dynamic risk assessment expertise and analytics that help in achieving positive results.</li>
                <li>Competitive insights and technical knowledge guidance to keep you informed</li>
                <li>Valuable tools and resources to support your business needs.</li>
              </ul>
              <h5 className="mb-4 mt-5">
                <b> Property/Casualty</b>
              </h5>
              <p>At Cylon Technologies, our goal is to offer a full range of solutions of your Auto/Motor exposures and coverage that include-</p>
              <ul>
                <li> Auto/Motor Liability Per Occurrence Facultative  </li>
                <li>Auto /Motor Liability Per Occurrence Excess of Loss Treaty</li>
                <li>Accident</li>
                <li>Transportation Liability</li>
                <li>Exposure Carve Outs</li>
                <li>Casualty Per Occurrence Facultative</li>
                <li>Quota Share Treaty</li>
                  </ul>
                  <p>We evaluate each risk alongside you and we take on the risk just as you take and every contract we sign is a promise we make directly to you.  Contact us to learn more about our reinsurance solutions.</p>
            </div>
            <div className="col-md-4">
              <div className="right_content">
                <div className="border-tb mb-5">
                  <h2 className="heading2 mt-0">Offerings</h2>
                  <p>
                  Our team of reinsurance experts has developed state-of-the-art reinsurance solutions that enable the carriers to handle their all reinsurance activities on a single platform with full financial control and auditing support. We have expertise in providing proportional and non-proportional reinsurance solutions in many forms across Property and Casualty Treaties such as-
                  </p>
                  <ul>
                    <li><b>Property Treaties –</b> Covers damage to underlying assets and direct or contingent business losses or interruptions caused by natural catastrophes and other perils  such as fire, theft etc.</li>
                    <li>
                      <b>Motor Treaties - </b> Covers original risks in terms of motor, property damage and bodily injury
                    </li>
                    <li>
                      <b>Casualty Treaties –</b> Covers general liability, product liability and professional indemnity.
                    </li>

                  </ul>

                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Reinsurance;
